import { render, staticRenderFns } from "./RelatedServices.vue?vue&type=template&id=635f999e&scoped=true&"
import script from "./RelatedServices.vue?vue&type=script&lang=ts&"
export * from "./RelatedServices.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedServices.vue?vue&type=style&index=0&id=635f999e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f999e",
  null
  
)

export default component.exports